import { render, staticRenderFns } from "./TransactionsPage.vue?vue&type=template&id=68d7cae5&scoped=true&"
import script from "./TransactionsPage.vue?vue&type=script&lang=js&"
export * from "./TransactionsPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsPage.vue?vue&type=style&index=0&id=68d7cae5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d7cae5",
  null
  
)

export default component.exports